import React from 'react';
import CrudTab from 'react/containers/pages/CrudTab';

class HosMapDisplay extends CrudTab {

  static tabName = 'Greenmile.HOSMap.screenName'

  initializeMap = () => {
    try {

      const selector = "#HosMapDisplay #mapToolbar";
      const map = Greenmile.Map.Utility.createDefaultMap("mapContainerHOS");
      const baseLayer = Greenmile.Map.Utility.createBaseLayer();

      map.addLayer(baseLayer);

      Monet.Session.HOS.map = map;
      Monet.Session.HOS.mapBaseLayer = baseLayer;
      Monet.Session.HOS.routeLayer = undefined;

      const options = { sourceSessionData: Monet.Session.HOS };
      const helper = new Monet.UI.Help('HosMapDisplay', Monet.I18n.getResourcesByKey('Greenmile.HOSMap.screenName'));
      const toolbar = new Greenmile.Toolbar.Map(map, selector, options, helper);

      toolbar.enable([
        toolbar.actions.searchAddressOnMap,
        toolbar.actions.points,
        toolbar.actions.street,
        toolbar.actions.fitToMarkers,
        toolbar.actions.zoom,
        toolbar.actions.source,
        toolbar.actions.hos
      ]);

      toolbar.render();

    } catch (e) {
      const error = new Monet.Exception.ReturnError(this,
        "Error on initialize map");
        error.console();
      }
    }

    componentDidMount() {
      Monet.Session["HOS"] = { "map": null };
      this.initializeMap();
      App.Views.HOSMaps.showFilter();
    }

    componentDidUpdate() {}

    render() {
      const { active } = this.props;
      const className = `gmTabs__panel ${(active) ? this.activeClassName : ''}`;

      return (
        <div className={className}>
          <div id="HosMapDisplay">
            <form id="form_HOSMaps">
              <div className="monetInlineAlerContainer"></div>
            </form>
            <div id="hosLayoutMap">
              <div id="adjustsLayoutContainer">
                <div id="mapToolbar"></div>
                <div id="mapContainerHOS"></div>
              </div>
            </div>
            <div id="btnShowLogBook" className="miniPlayer">
              <div className="showFullGrid"></div>
            </div>
            <div id="logBook">
              <div id="btnHideLogBook" className="gridStopsHide"></div>
              <ul>
                <li>
                  <a href="#chart">{Monet.I18n.getResourcesByKey('HOSMaps.tab.chart')}</a>
                </li>
                <li>
                  <a href="#summaryInformation">{Monet.I18n.getResourcesByKey('HOSMaps.tab.summary')}</a>
                </li>
              </ul>
              <div id="chart"></div>
              <div id="summaryInformation"></div>
            </div>
          </div>
        </div>
      );
    }

  }

  export default HosMapDisplay;
